import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";
import { fmtStamp as stamp } from "@/lib/format";

export function CalendarInviteButton({ t, onSaved }) {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const last = Object.values(t.invites || {}).map((x) => x.sent_at).sort().pop();
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/tracking/${t.id}/invites`);
      toast.success(`Sending ${data.invites_sent} calendar invite${data.invites_sent === 1 ? "" : "s"} to ${t.broker_name || "the broker"} and the flight team`);
      onSaved(data);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col gap-1" data-testid="calendar-invite">
      <button type="button" className="frame-btn" disabled={busy} onClick={send} data-testid="calendar-invite-send-btn">
        <CalendarPlus size={13} /> {busy ? "Sending…" : last ? "Resend calendar invite" : "Send calendar invite"}
      </button>
      {last && <span className="text-[0.72rem] text-zinc-300" data-testid="calendar-invite-sent-note">Last sent {stamp(last)}</span>}
    </div>
  );
}
